import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { formatDate } from "@angular/common";
import { parse } from 'date-fns';
import { DatePipe } from '@angular/common'
import { AuthService } from '../services/auth.service';
import { Login } from '../login/login';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {


  constructor(private router: Router, private datepipe: DatePipe, private authService: AuthService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    if (!localStorage.getItem('token')) {
 
      this.router.navigate(['/login']);
    } else {
      let data_login = this.datepipe.transform(localStorage.getItem('data_login'), 'yyyy-MM-dd h:mm:ss');
      let data_atual = this.datepipe.transform(new Date(), 'yyyy-MM-dd h:mm:ss');
      
      //Milisegundos
      let diferencaMS = Math.floor(<any>new Date(data_atual) - <any>Date.parse(data_login));
      //Segundos
      let diferencaSeg = diferencaMS / 1000;
      
      //Renova token caso necessario
      if(diferencaSeg >= (Number(localStorage.getItem('expires_in')) - 1000)){
        this.authService.refresh().subscribe((r: any) => {
          let login = new Login();
          login.login(r);
          return true;
        });
      }else{
        return true;
      }
 
     
    }
  }
}